import React, { useReducer, useEffect } from "react";

import Context from "./context";
import Html from "./html";
import Reducer from "./reducer";
import { initialState } from "./initialState";
import Loader from "../../components/loading";
import { loadData } from "./service";

const Profile = () => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        loadData(dispatch);
    }, []);

    return(
        <Context.Provider value={{state, dispatch}}>
            {!state.is_loading ? <Html/> : <Loader/>}
        </Context.Provider>
    );
}

export default Profile;